import { MainnetOnly } from '@/constant';
import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import {
    argentWallet,
    imTokenWallet,
    ledgerWallet,
    okxWallet,
    oneKeyWallet,
    trustWallet,
    uniswapWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { lazaiTestnet } from './lazaiTestnetChain';
export const projectId = 'e1b0a7ab8ea35f139488ce08f9a8afa0';

const { wallets: defaultWallets } = getDefaultWallets();
const wallets = [
    ...defaultWallets,
    {
        groupName: 'Other',
        wallets: [
            argentWallet,
            trustWallet,
            ledgerWallet,
            okxWallet,
            imTokenWallet,
            uniswapWallet,
            oneKeyWallet,
        ],
    },
];

const chainConfig = MainnetOnly
    ? {
          chains: [lazaiTestnet],
          appName: 'Lazpad Protocol',
          projectId: projectId,
          wallets,
      }
    : {
          chains: [lazaiTestnet],
          appName: 'Lazpad Protocol',
          projectId: projectId,
          wallets,
      };

export default getDefaultConfig(chainConfig as any);
